import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";

export const useImportPlanConfigViewModel = ({
  stateManager,
  checkedAreas = [],
  planDetails = {},
  setPlanDetails,
  selectedItems,
  isSuppliedByBuilder,
  onReset,
}) => {
  const [planFloors, setPlanFloors] = useState([]);
  const [availableFloors, setAvailableFloors] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState({});
  const [dismissedOptionalCategories, setDismissedOptionalCategories] =
    useState({});

  const getFloors = () => {
    stateManager.run(async () => {
      const response = await homeService.floors.getAll({
        sort: "displayOrder asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setAvailableFloors(response.data);
      }
    });
  };

  const checkedAreaIds = checkedAreas.map((area) => area.id);

  const itemExists = planDetails.planAreas?.some(
    (planArea) =>
      checkedAreaIds.includes(planArea.id) &&
      planArea.materials.some(
        (mat) => mat.materialId === selectedItems.materialId
      )
  );

  const handleAddItem = () => {
    const updatedPlanDetails = {
      ...planDetails,
      planAreas: planDetails.planAreas.map((planArea) => {
        if (!checkedAreaIds.includes(planArea.id)) {
          return planArea;
        }

        const updatedMaterials = planArea.materials.map((material) => {
          if (
            material.removalReason &&
            material.category?.categoryId === selectedItems.category?.categoryId
          ) {
            return { ...material, removalReason: undefined };
          }
          return material;
        });

        return {
          ...planArea,
          materials: [
            ...updatedMaterials,
            {
              ...selectedItems,
              quantity: 1,
              planConfigStatus:
                selectedMaterial.isRequired ||
                selectedMaterial.planConfigStatus === "IsAdded"
                  ? "IsAdded"
                  : null,
              referenceId: selectedMaterial.referenceId,
              suppliedByBuilder: isSuppliedByBuilder,
              itemCode: selectedItems.category.itemCode,
              itemDescription: selectedItems.category.itemDescription,
              categoryId: selectedItems.category.categoryId,
            },
          ],
        };
      }),
    };

    setPlanDetails(updatedPlanDetails);
    onReset();
  };

  return {
    getFloors,
    planFloors,
    setPlanFloors,
    availableFloors,
    dismissedOptionalCategories,
    setDismissedOptionalCategories,
    selectedMaterial,
    setSelectedMaterial,
    itemExists,
    handleAddItem,
  };
};
